import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import "../styles/Reviews.css";

export default function Reviews() {
  const [active, setActive] = useState("ovatu");

  const ovatuRef = useRef(null);
  const googleRef = useRef(null);

  /*
    Listen for height messages from iframes.
    Only apply height updates from the currently active iframe.
  */
  useEffect(() => {
    const handleMessage = (event) => {
      if (!event.data || !event.data.type) return;

      if (event.data.type === "OVATU_REVIEWS_HEIGHT" && active === "ovatu") {
        if (ovatuRef.current) {
          ovatuRef.current.style.height = `${event.data.height}px`;
        }
      }

      if (event.data.type === "GOOGLE_REVIEWS_HEIGHT" && active === "google") {
        if (googleRef.current) {
          googleRef.current.style.height = `${event.data.height}px`;
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [active]);

  return (
    <main className="reviews-container">
      <Helmet>
        <title>Client Reviews | Lash With Brittany</title>
        <meta
          name="description"
          content="Read verified client reviews from Ovatu and Google for Lash With Brittany."
        />
        <link rel="canonical" href="https://lashwithbrittany.com/reviews" />
      </Helmet>

      <section className="reviews-intro">
        <h1>Client Reviews</h1>
        <p className="reviews-subtitle">Real experiences from real clients</p>
        <p className="reviews-description">
          Browse verified reviews from Ovatu bookings or Google to see what
          clients are saying about their experience.
        </p>
      </section>

      {/* Toggle */}
      <div className="reviews-toggle">
        <div
          className="reviews-toggle-indicator"
          style={{
            transform: active === "google" ? "translateX(100%)" : "translateX(0)"
          }}
        />
        <button
          className={active === "ovatu" ? "active" : ""}
          onClick={() => setActive("ovatu")}
        >
          Ovatu Reviews
        </button>
        <button
          className={active === "google" ? "active" : ""}
          onClick={() => setActive("google")}
        >
          Google Reviews
        </button>
      </div>

    {/* Review Card */}
    <div className="reviews-widget-shell">
        <div className="reviews-outer-frame">
            <div className="reviews-card">
            <div className="reviews-frame">
                <iframe
                ref={ovatuRef}
                src="/reviews-ovatu-embed.html"
                title="Ovatu Reviews"
                className={`reviews-iframe ${active === "ovatu" ? "visible" : ""}`}
                scrolling="no"
                />

                <iframe
                ref={googleRef}
                src="/google-reviews-embed.html"
                title="Google Reviews"
                className={`reviews-iframe ${active === "google" ? "visible" : ""}`}
                scrolling="no"
                />
            </div>
            </div>
        </div>
    </div>

    </main>
  );
}
